import type { VariantAxis } from "../types/category";

export function formatVariantValue(value: string | number, axis: VariantAxis): string {
  return axis.displayFormat.replace("{value}", String(value));
}

export function formatVariantLabel(
  variantValues: Record<string, string | number>,
  axes: VariantAxis[],
): string {
  return axes
    .map((axis) => {
      const val = variantValues[axis.key];
      return val !== undefined ? formatVariantValue(val, axis) : "\u2014";
    })
    .join(" / ");
}
